// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ClientesPreencher_PublicUpdateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /clientes/preencher/update
 *
 * Public endpoint — returns minimal confirmation after successful update.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ClientesPreencher_PublicUpdateResponseDados {
cliente_id?: number
cliente_nome?: string
}

export type ClientesPreencher_PublicUpdateResponse = ApiResponse<ClientesPreencher_PublicUpdateResponseDados>;

registerResponseContract('ClientesPreencher_PublicUpdateResponse', {
  cliente_id:   { type: 'number',  required: false },
  cliente_nome: { type: 'string',  required: false },
})
